<ng-container [formGroup]="form">
  <div class="grid-x">
    <div class="cell large-12 medium-12 small-12 bold">
      <div class="section-header" [ngClass]="{ 'active' : true }" (click)="toggleOpen()">
        <span class="margin-right">Completion Information</span>
        <button class="icon-button">
          @if (isOpen == false) {
            <svg-icon icon="icon-caret-right"></svg-icon>
          }
          @if (isOpen == true) {
            <svg-icon icon="icon-caret-down"></svg-icon>
          }
        </button>
      </div>
    </div>
  </div>
  <div class="grid-x margin-top" [ngClass]="{ 'hideSection': isOpen == false }">
    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Date Put Into Production:
      @if (fieldHasNotes('completionInfo|productionDate') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'completionInfo|productionDate'" [notes]="getFilteredNotes('completionInfo|productionDate')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <common-date-picker [id]="'productionDate'" (dateUpdated)="onDateUpdated($event, 'productionDate')" [initialDate]="productionDate" [disabled]="form?.get('productionDate')?.disabled"></common-date-picker>

    </div>


    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Producing Formation:
      @if (fieldHasNotes('completionInfo|prodFormation') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'completionInfo|prodFormation'" [notes]="getFilteredNotes('completionInfo|prodFormation')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <!--<input type="text" formControlName="prodFormation" />-->

      <select formControlName="prodFormation">

        @for (formation of formations; track formation) {
          <option [value]="formation.code">{{formation.definition}}</option>
        }
      </select>

    </div>

    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Perforated Intervals and Number of Shots:
      @if (fieldHasNotes('completionInfo|intervalsAndShots') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'completionInfo|intervalsAndShots'" [notes]="getFilteredNotes('completionInfo|intervalsAndShots')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <input type="text" formControlName="intervalsAndShots" />

    </div>

    <div class="cell small-7 large-7 medium-7 bold">
      Frac Company:
      @if (fieldHasNotes('completionInfo|fracCompany') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'completionInfo|fracCompany'" [notes]="getFilteredNotes('completionInfo|fracCompany')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>

    <div class="cell small-2 large-2 medium-2">
      <input type="text" formControlName="fracCompany" />
    </div>


    <div class="cell padding-right">
      <div>
        <p class="bold">Type of Completion</p>
        <div class="checkbox">
          <input class="show-for-sr" id="openHole" type="checkbox" formControlName="openHole" (change)="onOpenHoleChecked($event)" />
          <label for="openHole" class="bold">
            Open Hole

            <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
          </label>
          @if (fieldHasNotes('completionInfo|openHole') || reviewStates?.includes(applicationState)) {
            <span class="padding-left">
              <view-notes [fieldName]="'completionInfo|openHole'" [notes]="getFilteredNotes('completionInfo|openHole')" (notesRequested)="handleNoteRequested($event)"></view-notes>
            </span>
          }
        </div>
        <div class="checkbox">
          <input class="show-for-sr" id="thruCasing" type="checkbox" formControlName="thruCasing" (change)="onThruCasingChecked($event)" />
          <label for="thruCasing" class="bold">
            Through Casing

            <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
          </label>
          @if (fieldHasNotes('completionInfo|thruCasing') || reviewStates?.includes(applicationState)) {
            <span class="padding-left">
              <view-notes [fieldName]="'completionInfo|thruCasing'" [notes]="getFilteredNotes('completionInfo|thruCasing')" (notesRequested)="handleNoteRequested($event)"></view-notes>
            </span>
          }
        </div>
        <div class="checkbox">
          <input class="show-for-sr" id="slottedLiner" type="checkbox" formControlName="slottedLiner" (change)="onSlottedLinerChecked($event)" />
          <label for="slottedLiner" class="bold">
            Slotted Liner
            <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
          </label>
          @if (fieldHasNotes('completionInfo|slottedLiner') || reviewStates?.includes(applicationState)) {
            <span class="padding-left">
              <view-notes [fieldName]="'completionInfo|slottedLiner'" [notes]="getFilteredNotes('completionInfo|slottedLiner')" (notesRequested)="handleNoteRequested($event)"></view-notes>
            </span>
          }
        </div>
      </div>





      <hr />
      <div>
        <p class="bold">Method of shot, acid, or fracture treatments, production tests, pressures, etc.</p>

        <div style="float:left; padding-right: 2em">
          <label class="bold">
            SHOT
          </label>
          @if (fieldHasNotes('completionInfo|shotLbs') || reviewStates?.includes(applicationState)) {
            <span class="padding-left">
              <view-notes [fieldName]="'completionInfo|shotLbs'" [notes]="getFilteredNotes('completionInfo|shotLbs')" (notesRequested)="handleNoteRequested($event)"></view-notes>
            </span>
          }
          <div class="cell small-2 large-2 medium-2">
            <input type="number" formControlName="shotLbs" />
            <p>Lbs.</p>
          </div>
          @if (fieldHasNotes('completionInfo|shotQts') || reviewStates?.includes(applicationState)) {
            <span class="padding-left">
              <view-notes [fieldName]="'completionInfo|shotQts'" [notes]="getFilteredNotes('completionInfo|shotQts')" (notesRequested)="handleNoteRequested($event)"></view-notes>
            </span>
          }

          <div class="cell small-2 large-2 medium-2">
            <input type="number" formControlName="shotQts" />
            <p>Qts. </p>

          </div>

          @if (fieldHasNotes('completionInfo|shotType') || reviewStates?.includes(applicationState)) {
            <span class="padding-left">
              <view-notes [fieldName]="'completionInfo|shotType'" [notes]="getFilteredNotes('completionInfo|shotType')" (notesRequested)="handleNoteRequested($event)"></view-notes>
            </span>
          }

          <div class="cell small-2 large-2 medium-2">

            <input type="text" formControlName="shotType" />


            <p>Type</p>

          </div>



        </div>

        <div style="float:left; padding-right: 2em">
          <label class="bold">
            ACID
          </label>
          @if (fieldHasNotes('completionInfo|acidGals') || reviewStates?.includes(applicationState)) {
            <span class="padding-left">
              <view-notes [fieldName]="'completionInfo|acidGals'" [notes]="getFilteredNotes('completionInfo|acidGals')" (notesRequested)="handleNoteRequested($event)"></view-notes>
            </span>
          }
          <div class="cell small-2 large-2 medium-2">
            <input type="number" formControlName="acidGals" />

            <p>Gals</p>
          </div>

          @if (fieldHasNotes('completionInfo|acidType') || reviewStates?.includes(applicationState)) {
            <span class="padding-left">
              <view-notes [fieldName]="'completionInfo|acidType'" [notes]="getFilteredNotes('completionInfo|acidType')" (notesRequested)="handleNoteRequested($event)"></view-notes>
            </span>
          }
          <div class="cell small-2 large-2 medium-2">
            <input type="text" formControlName="acidType" />


            <p>Type</p>
          </div>
          @if (fieldHasNotes('completionInfo|acidPercent') || reviewStates?.includes(applicationState)) {
            <span class="padding-left">
              <view-notes [fieldName]="'completionInfo|acidPercent'" [notes]="getFilteredNotes('completionInfo|acidTypeacidPercent')" (notesRequested)="handleNoteRequested($event)"></view-notes>
            </span>
          }

          <div class="cell small-2 large-2 medium-2">
            <input type="number" formControlName="acidPercent" />

            <p>Percent</p>
          </div>
        </div>

        <div style="float:left; padding-right: 2em">
          <label class="bold">
            FRAC FLUIDS
          </label>
          @if (fieldHasNotes('completionInfo|waterGals') || reviewStates?.includes(applicationState)) {
            <span class="padding-left">
              <view-notes [fieldName]="'completionInfo|waterGals'" [notes]="getFilteredNotes('completionInfo|waterGals')" (notesRequested)="handleNoteRequested($event)"></view-notes>
            </span>
          }
          <div class="cell small-2 large-2 medium-2">
            <input type="number" formControlName="waterGals" />

            <p>Water (gals)</p>
          </div>
          @if (fieldHasNotes('completionInfo|waterBbl') || reviewStates?.includes(applicationState)) {
            <span class="padding-left">
              <view-notes [fieldName]="'completionInfo|waterBbl'" [notes]="getFilteredNotes('completionInfo|waterBbl')" (notesRequested)="handleNoteRequested($event)"></view-notes>
            </span>
          }
          <div class="cell small-2 large-2 medium-2">
            <input type="number" formControlName="waterBbl" />
            <p>Water (bbl)</p>
          </div>
          @if (fieldHasNotes('completionInfo|fracCos') || reviewStates?.includes(applicationState)) {
            <span class="padding-left">
              <view-notes [fieldName]="'completionInfo|fracCos'" [notes]="getFilteredNotes('completionInfo|fracCos')" (notesRequested)="handleNoteRequested($event)"></view-notes>
            </span>
          }
          <div class="cell small-2 large-2 medium-2">
            <input type="number" formControlName="fracCos" />


            <p>CO2 (tons) </p>
          </div>
          @if (fieldHasNotes('completionInfo|fracN2') || reviewStates?.includes(applicationState)) {
            <span class="padding-left">
              <view-notes [fieldName]="'completionInfo|fracN2'" [notes]="getFilteredNotes('completionInfo|fracN2')" (notesRequested)="handleNoteRequested($event)"></view-notes>
            </span>
          }
          <div class="cell small-2 large-2 medium-2">
            <input type="number" formControlName="fracN2" />

            <p>N2 (mscf)</p>
          </div>
        </div>

        <div style="float:left; padding-right: 2em">
          <label class="bold">
            SAND
          </label>
          @if (fieldHasNotes('completionInfo|sandLbs') || reviewStates?.includes(applicationState)) {
            <span class="padding-left">
              <view-notes [fieldName]="'completionInfo|sandLbs'" [notes]="getFilteredNotes('completionInfo|sandLbs')" (notesRequested)="handleNoteRequested($event)"></view-notes>
            </span>
          }
          <div class="cell small-2 large-2 medium-2">
            <input type="number" formControlName="sandLbs" />




            <p>Lbs.</p>
          </div>
          @if (fieldHasNotes('completionInfo|sandSks') || reviewStates?.includes(applicationState)) {
            <span class="padding-left">
              <view-notes [fieldName]="'completionInfo|sandSks'" [notes]="getFilteredNotes('completionInfo|sandSks')" (notesRequested)="handleNoteRequested($event)"></view-notes>
            </span>
          }

          <div class="cell small-2 large-2 medium-2">
            <input type="number" formControlName="sandSks" />

            <p>Sks.</p>
          </div>
        </div>

        <div style="float:left; padding-right: 2em">
          <label class="bold">
            PRESSURES (psi)
          </label>
          @if (fieldHasNotes('completionInfo|pressureBreakdown') || reviewStates?.includes(applicationState)) {
            <span class="padding-left">
              <view-notes [fieldName]="'completionInfo|pressureBreakdown'" [notes]="getFilteredNotes('completionInfo|pressureBreakdown')" (notesRequested)="handleNoteRequested($event)"></view-notes>
            </span>
          }
          <div class="cell small-2 large-2 medium-2">
            <input type="number" formControlName="pressureBreakdown" />
            <p>Breakdown</p>
          </div>
          @if (fieldHasNotes('completionInfo|pressureATP') || reviewStates?.includes(applicationState)) {
            <span class="padding-left">
              <view-notes [fieldName]="'completionInfo|pressureATP'" [notes]="getFilteredNotes('completionInfo|pressureATP')" (notesRequested)="handleNoteRequested($event)"></view-notes>
            </span>
          }
          <div class="cell small-2 large-2 medium-2">
            <input type="number" formControlName="pressureATP" />


            <p>ATP</p>
          </div>
          @if (fieldHasNotes('completionInfo|pressureISIP') || reviewStates?.includes(applicationState)) {
            <span class="padding-left">
              <view-notes [fieldName]="'completionInfo|pressureISIP'" [notes]="getFilteredNotes('completionInfo|pressureISIP')" (notesRequested)="handleNoteRequested($event)"></view-notes>
            </span>
          }
          <div class="cell small-2 large-2 medium-2">
            <input type="number" formControlName="pressureISIP" />

            <p>ISIP</p>
          </div>
          @if (fieldHasNotes('completionInfo|pressureSIP') || reviewStates?.includes(applicationState)) {
            <span class="padding-left">
              <view-notes [fieldName]="'completionInfo|pressureSIP'" [notes]="getFilteredNotes('completionInfo|pressureSIP')" (notesRequested)="handleNoteRequested($event)"></view-notes>
            </span>
          }
          <div class="cell small-2 large-2 medium-2">
            <input type="number" formControlName="pressureSIP" />


            <p>5 min. SIP</p>
          </div>
          @if (fieldHasNotes('completionInfo|pressureAvg') || reviewStates?.includes(applicationState)) {
            <span class="padding-left">
              <view-notes [fieldName]="'completionInfo|pressureAvg'" [notes]="getFilteredNotes('completionInfo|pressureAvg')" (notesRequested)="handleNoteRequested($event)"></view-notes>
            </span>
          }

          <div class="cell small-2 large-2 medium-2">
            <input type="number" formControlName="pressureAvg" />
            <p>Avg. Rate</p>
          </div>

        </div>

      </div>
    </div>
    <hr />

    <p class="bold">Method of fluid containment</p>

    <table>
      <caption>Completion Information</caption>
      <thead>
        <tr>
          <th>FLUIDS:</th>
        </tr>


      </thead>
      <tbody>

        <tr>
          <td>SWAB</td>

          <td>
            PIT
            <div class="checkbox">
              <input class="show-for-sr" id="swabFrac" type="checkbox" formControlName="swabFrac" (change)="onSwabFracChecked($event)" />
              <label for="swabFrac">
                <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
              </label>

              @if (fieldHasNotes('completionInfo|swabFrac') || reviewStates?.includes(applicationState)) {
                <span class="padding-left">
                  <view-notes [fieldName]="'completionInfo|swabFrac'" [notes]="getFilteredNotes('completionInfo|swabFrac')" (notesRequested)="handleNoteRequested($event)"></view-notes>
                </span>
              }


            </div>
          </td>
          <td>
            FRAC TANK
            <div class="checkbox">
              <input class="show-for-sr" id="swabPit" type="checkbox" formControlName="swabPit" (change)="onSwabPitChecked($event)" />
              <label for="swabPit">
                <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
              </label>

              @if (fieldHasNotes('completionInfo|swabPit') || reviewStates?.includes(applicationState)) {
                <span class="padding-left">
                  <view-notes [fieldName]="'completionInfo|swabPit'" [notes]="getFilteredNotes('completionInfo|swabPit')" (notesRequested)="handleNoteRequested($event)"></view-notes>
                </span>
              }


            </div>

          </td>


        </tr>
        <tr>
          <td>FLOWBACK</td>
          <td>
            <div class="checkbox">

              <input class="show-for-sr" id="flowFrac" type="checkbox" formControlName="flowFrac" (change)="onFlowFracChecked($event)" />
              <label for="flowFrac" class="bold">
                <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
              </label>

              @if (fieldHasNotes('completionInfo|flowFrac') || reviewStates?.includes(applicationState)) {
                <span class="padding-left">
                  <view-notes [fieldName]="'completionInfo|flowFrac'" [notes]="getFilteredNotes('completionInfo|flowFrac')" (notesRequested)="handleNoteRequested($event)"></view-notes>
                </span>
              }



            </div>
          </td>
          <td>
            <div class="checkbox">

              <input class="show-for-sr" id="flowPit" type="checkbox" formControlName="flowPit" (change)="onFlowPitChecked($event)" />
              <label for="flowPit" class="bold">
                <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
              </label>

              @if (fieldHasNotes('completionInfo|flowPit') || reviewStates?.includes(applicationState)) {
                <span class="padding-left">
                  <view-notes [fieldName]="'completionInfo|flowPit'" [notes]="getFilteredNotes('completionInfo|flowPit')" (notesRequested)="handleNoteRequested($event)"></view-notes>
                </span>
              }
            </div>
          </td>
        </tr>
      </tbody>
    </table>


    <div class="cell bold">
      Date Treated:
      @if (fieldHasNotes('completionInfo|dateTreated') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'completionInfo|dateTreated'" [notes]="getFilteredNotes('completionInfo|dateTreated')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <common-date-picker [id]="'dateTreated'" (dateUpdated)="onDateUpdated($event, 'dateTreated')" [initialDate]="dateTreated" [disabled]="form?.get('dateTreated')?.disabled"></common-date-picker>

    </div>

  </div>
</ng-container>
